<template>
        <!-- Footer-->
    <footer class="footer bg-black small text-center text-white-50">
        <div class="container">Copyright © Miskah Alfiyyah Kulsum 2021</div>
    </footer>
</template>

<script>
export default {
    name: 'Footer'
}
</script>
